import { Autoplay, Navigation } from 'swiper/modules';

export default function () {
    window.addEventListener('load', () => {
        const anySwiper = document.querySelector('.swiper:not(.product-images)');

        if (!anySwiper) return;

        import('swiper').then((module) => {
            const Swiper = module.default;
            const cs = getComputedStyle(document.documentElement);

            //MAIN BANNER
            const mainBanner = new Swiper('.main-banner', {
                modules: [Navigation, Autoplay],
                preloadImages: false,
                autoplay: {
                    delay: 7000
                },
                lazy: true,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next.main-swiper-button',
                    prevEl: '.swiper-button-prev.main-swiper-button'
                },
                on: {
                    beforeTransitionStart: function (instance) {
                        const currentSlide = instance.slides[instance.activeIndex];
                        const slideImg = currentSlide.querySelector('img');
                        
                        if (slideImg.hasAttribute('src')) return;

                        currentSlide.classList.add('loaded');
                        slideImg.setAttribute('src', slideImg.getAttribute('data-src'));
                    }
                }
            });

            const secondBanner = new Swiper('.second-banner', {
                modules: [Navigation],
                preloadImages: false,
                lazy: true,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next.second-swiper-button',
                    prevEl: '.swiper-button-prev.second-swiper-button'
                },
                on: {
                    beforeTransitionStart: function (instance) {
                        const currentSlide = instance.slides[instance.activeIndex];
                        const slideImg = currentSlide.querySelector('img');

                        if (slideImg.hasAttribute('src')) return;

                        currentSlide.classList.add('loaded');
                        slideImg.setAttribute('src', slideImg.getAttribute('data-src'));
                    }
                }
            });


            //MAIN PAGE PRODUCTS
            const breakpoints = {
                1: {},
                375: {},
                601: {},
                1100: {},
                1280: {}
            };

            const slider1 = new Swiper('.mainpage-products-slider .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.products-slider-button',
                    prevEl: '.swiper-button-prev.products-slider-button'
                },
                loop: true,
                breakpoints: breakpoints,
                slidesPerView: 1,
                spaceBetween: 24,
            });

            slider1.on('breakpoint', function () {
                slider1.update();
            });


            //PRODUCERS
            const producersBanner = new Swiper('.producers-banner .swiper', {
                modules: [Navigation],
                preloadImages: false,
                navigation: {
                    nextEl: '.swiper-button-next.producer-button',
                    prevEl: '.swiper-button-prev.producer-button'
                },
                loop: false,
                spaceBetween: 44,
                breakpoints: {
                    1: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    601: {
                        slidesPerView: 3
                    },
                    1100: {
                        slidesPerView: 4
                    },
                    1280: {
                        slidesPerView: 5
                    },
                    1681: {
                        slidesPerView: 6
                    }
                }
            });
        });
    }, false);
}